import { DataBean } from "../DataBean";

export class QualityReprocessing extends DataBean {

  public async getQualityReprocessingCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityReprocessingCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

    public async getQualityReprocessingRender( page: number, rows: number,year: number, properties: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityReprocessingRender_Number_Number_Number_java.util.Map",
      [page, rows, year, properties]
    );
  }

  public async deleteQualityReprocessing(idqualityreprocessing: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityReprocessing_Number", [idqualityreprocessing]);
  }

  public async importReprocessReviews(idEmployee: number, data: string): Promise<any> {
      return this.getCustomService("ProcessContractERP", "java.util.List_importReprocessReviews_Number_String", [idEmployee, data]);
  }

  public async updateQualityReprocessing(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityReprocessing_updateQualityReprocessing_com.orange.finance.processcontract.bean.QualityReprocessing",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityReprocessing",
        },
      ]
    );
  }
}
